export default __webpack_public_path__ + "static/media/M_wdt_c_cap_6.5bd77ce8.mp3";